// extracted by mini-css-extract-plugin
module.exports = {"logoBox":"logoBox-1ntx2_8x","logo":"logo-2cY0sDhi","sub_logo":"sub_logo-2X4I4Ygk"};